<template>
  <div class="ele-body">
    <el-card shadow="never" body-style="padding-bottom: 0;">
      <el-row :gutter="15">
        <el-col :lg="6" style="margin-bottom: 15px;">
          <ele-pro-table
            ref="table"
            :datasource="url"
            :columns="columns"
            height="calc(100vh - 261px)"
            :need-page="false"
            :toolkit="[]"
            :current.sync="current"
            highlight-current-row
            class="dict-table"
            tool-class="ele-toolbar-actions"
            @done="done">
            <template slot="toolbar">
              <el-button
                v-if="permission.includes('sys:dictionary:add')"
                size="small"
                type="primary"
                icon="el-icon-plus"
                class="ele-btn-icon"
                @click="openEdit(null)">添加
              </el-button>
              <el-button
                v-if="permission.includes('sys:dictionary:edit')"
                size="small"
                type="warning"
                icon="el-icon-edit"
                class="ele-btn-icon"
                :disabled="!current"
                @click="openEdit(current)">编辑
              </el-button>
              <el-button
                v-if="permission.includes('sys:dictionary:delete')"
                size="small"
                type="danger"
                icon="el-icon-delete"
                class="ele-btn-icon"
                :disabled="!current"
                @click="remove">删除
              </el-button>
            </template>
          </ele-pro-table>
        </el-col>
        <el-col :lg="18" style="margin-bottom: 15px;">
          <dict-data v-if="current" :dict-id="current.id" />
        </el-col>
      </el-row>
    </el-card>
    <dict-edit :visible.sync="showEdit" :data="editData" @done="reload" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import DictData from './dict-data';
import DictEdit from './dict-edit';

export default {
  name: 'Dictionary',
  components: { DictData, DictEdit },
  computed: {
    ...mapGetters(['permission'])
  },
  data() {
    return {
      url: '/dict/index',
      columns: [
        { columnKey: 'index', type: 'index', label: '序号', width: 55, align: 'center' },
        { prop: 'name', label: '字典名称', showOverflowTooltip: true, minWidth: 100 },
        { prop: 'code', label: '编码', showOverflowTooltip: true, minWidth: 90 }
      ],
      current: null,
      showEdit: false,
      editData: null
    };
  },
  methods: {
    done(res) {
      if (res.data && res.data.length > 0) {
        this.$refs.table.setCurrentRow(res.data[0]);
      }
    },
    reload() {
      this.$refs.table.reload();
    },
    openEdit(row) {
      this.editData = row;
      this.showEdit = true;
    },
    remove() {
      this.$confirm('确定要删除选中的字典吗?', '提示', { type: 'warning' }).then(() => {
        const loading = this.$loading({ lock: true });
        this.$http.post('/dict/delete', { id: this.current.id }).then((res) => {
          loading.close();
          if (res.data.code === 0) {
            this.$message.success(res.data.msg);
            this.reload();
          } else {
            this.$message.error(res.data.msg);
          }
        }).catch((e) => {
          loading.close();
          this.$message.error(e.message);
        });
      }).catch(() => {});
    }
  }
};
</script>

<style scoped>
.dict-table ::v-deep .el-table__row {
  cursor: pointer;
}
</style>
